import React from "react";
import { HomeItem } from "../components/HomeItem";

// Der Hero bringt seine eigene H1 mit – hier kein zusätzlicher Seitentitel.
export const Home = () => <HomeItem />;
